import EncoderWavWorkerCode from './EncoderWavWorkerCode.js';
import EncoderWavWorker from './EncoderWavWorker';
// import WebWorker from "./mp3worker.js";
// import convertWav from "./audioConvertWav";

//const mp3Worker = new Worker(WebWorker);

export default class RecorderService {
  constructor () {
    window.AudioContext = window.AudioContext || window.webkitAudioContext

    this.em = document.createDocumentFragment()

    this.state = 'inactive'

    this.chunks = []
    this.chunkType = ''

    this.encoderMimeType = 'audio/wav'
    this.mediaEncoderMimeType = 'audio/webm'
    this.alt_mediaEncoderMimeType = 'audio/mp4';
    //this.mediaEncoderMimeType = 'audio/mp4'

    this.config = {
      manualEncoderId: 'wav',
      micGain: 1.0,
      processorBufferSize: 2048,
      stopTracksAndCloseCtxWhenFinished: true,
      usingMediaRecorder: typeof window.MediaRecorder !== 'undefined',
      //usingMediaRecorder: false,
      userMediaConstraints: { audio: true }
      //userMediaConstraints: { audio: { echoCancellation: false } }
    }
    
  }

  /*
  async readChunk (chunk) {
    let fr_result = await new Promise((resolve, reject) => {
      let fr = new FileReader();
      fr.onload = x => resolve(fr.result);
      fr.readAsArrayBuffer(new Blob(chunk, {type: "audio/webm"}));
    });
    //console.log("YO",chunk,fr_result);
    return fr_result;
  }

  async audioWebmToWav (chunk) {
    //let e = await this.readChunk(chunk);
    //const buffer = e.target.result;
    let buffer = await this.readChunk(chunk);
    let data = await this.audioCtx.decodeAudioData(buffer);
    const wavBuf = convertWav(data, {});
    //let wavBlob = new Blob([new DataView(wavBuf)], {type: "audio/wav"});
    
    //return wavBlob;
    return wavBuf;
  }

  async audioWavToMp3 (wavBuf) {
    //let e = await this.readFile(chunk);
    //const buffer = e.target.result;
    //let data = await this.audioCtx.decodeAudioData(buffer);
    //const wavBuf = convertWav(data, {});
    const mp3Worker = new Worker(WebWorker);
    mp3Worker.postMessage({
      cmd: "init",
      config: {bitRate: 128}
    });
    mp3Worker.postMessage({cmd: "encode", rawInput: wavBuf});
    mp3Worker.postMessage({cmd: "finish"});
    let wavBlob = await new Promise((resolve, reject) => {
      try {
        mp3Worker.onmessage = (e) => {
          if (e.data.cmd === "end") {
            //const mp3Blob = new Blob(e.data.buf, {type: "audio/mpeg"});
            //resolve(mp3Blob);
            mp3Worker.terminate();
            resolve(e.data.buf);
            
            //MediaRecorderClass.checkAndExecFn(cb, mp3Blob);
          }
        };
      } catch (error) {
        console.log("ERROR",error);
        reject(error);
      }
    });
    return wavBlob;
  }
  */

  async pauseRecording () {
    if (this.state !== 'recording') {
      return;
    }

    if (this.config.usingMediaRecorder) {
      this.mediaRecorder.pause();
    } else {

    }
    this.state = 'paused';
  }

  async unpauseRecording () {
    if (this.state !== 'paused') {
      return;
    }

    if (this.config.usingMediaRecorder) {
      this.mediaRecorder.resume();
    } else {

    }
    this.state = 'recording';
  }

  /* Returns promise */
  startRecording () {
    if (this.state !== 'inactive') {
      return
    }

    // This is the case on ios/chrome, when clicking links from within ios/slack (sometimes), etc.
    if (!window.navigator || !window.navigator.mediaDevices || !window.navigator.mediaDevices.getUserMedia) {
      alert('Sorry! Browser Not Supported. If on an iOS device, please use Safari.') // temp: helps when testing for strange issues on ios/safari
      return false;
    }

    this.audioCtx = new window.AudioContext()
    this.micGainNode = this.audioCtx.createGain()
    this.outputGainNode = this.audioCtx.createGain()

    // If not using MediaRecorder(i.e. safari and edge), then a script processor is required. It's optional
    // on browsers using MediaRecorder and is only useful if wanting to do custom analysis or manipulation of
    // recorded audio data.
    if (!this.config.usingMediaRecorder) {
      this.processorNode = this.audioCtx.createScriptProcessor(this.config.processorBufferSize, 1, 1) // TODO: Get the number of channels from mic
    }

    // Create stream destination on chrome/firefox because, AFAICT, we have no other way of feeding audio graph output
    // in to MediaRecorder. Safari/Edge don't have this method as of 2018-04.
    if (this.audioCtx.createMediaStreamDestination) {
      this.destinationNode = this.audioCtx.createMediaStreamDestination()
    }
    else {
      this.destinationNode = this.audioCtx.destination
    }

    // Create web worker for doing the encoding
    if (!this.config.usingMediaRecorder) {
      //this.encoderWorker = new Worker('js/encoder-wav-worker.js')
      this.encoderWorker = new EncoderWavWorker(EncoderWavWorkerCode);
      
      this.encoderMimeType = 'audio/wav'

      this.encoderWorker.addEventListener('message', (e) => {
        let event = new Event('dataavailable')
        event.data = new Blob(e.data, { type: this.encoderMimeType })
        this._onDataAvailable(event)
      })
    }

    // This will prompt user for permission if needed
    return window.navigator.mediaDevices.getUserMedia(this.config.userMediaConstraints)
      .then((stream) => {
        this._startRecordingWithStream(stream)
      })
      .catch((error) => {
        alert('Error with getUserMedia: ' + error.message) // temp: helps when testing for strange issues on ios/safari
        console.log(error)
      })
  }

  _startRecordingWithStream (stream) {
    this.micAudioStream = stream

    this.inputStreamNode = this.audioCtx.createMediaStreamSource(this.micAudioStream)
    this.audioCtx = this.inputStreamNode.context

    // Allow optionally hooking in to audioGraph inputStreamNode, useful for meters
    if (this.onGraphSetupWithInputStream) {
      this.onGraphSetupWithInputStream(this.inputStreamNode)
    }

    this.inputStreamNode.connect(this.micGainNode)
    this.micGainNode.gain.setValueAtTime(this.config.micGain, this.audioCtx.currentTime)

    let nextNode = this.micGainNode

    this.state = 'recording'

    if (this.processorNode) {
      nextNode.connect(this.processorNode)
      this.processorNode.connect(this.outputGainNode)
      this.processorNode.onaudioprocess = (e) => this._onAudioProcess(e)
    }
    else {
      nextNode.connect(this.outputGainNode)
    }

    this.outputGainNode.connect(this.destinationNode)

    if (this.config.usingMediaRecorder) {
      if (MediaRecorder.isTypeSupported(this.mediaEncoderMimeType)) {
        this.mediaRecorder = new MediaRecorder(this.destinationNode.stream,{mimeType:this.mediaEncoderMimeType});
      } else {
        this.mediaRecorder = new MediaRecorder(this.destinationNode.stream,{mimeType:this.alt_mediaEncoderMimeType});
      }
      this.mediaRecorder.addEventListener('dataavailable', (evt) => this._onDataAvailable(evt))
      this.mediaRecorder.addEventListener('error', (evt) => this._onError(evt))

      this.mediaRecorder.start()
    }
    else {
      // Output gain to zero to prevent feedback. Seems to matter only on Edge, though seems like should matter
      // on iOS too.  Matters on chrome when connecting graph to directly to audioCtx.destination, but we are
      // not able to do that when using MediaRecorder.
      this.outputGainNode.gain.setValueAtTime(0, this.audioCtx.currentTime)
    }
  }

  stopRecording () {
    if (this.state === 'inactive') {
      return
    }

    if (this.config.usingMediaRecorder) {
      this.state = 'inactive'
      this.mediaRecorder.stop()
    }
    else {
      this.state = 'inactive'
      this.encoderWorker.postMessage(['dump', this.audioCtx.sampleRate])
    }
  }

  _onAudioProcess (e) {
    //console.log("_onAudioProcess");
    if (this.config.broadcastAudioProcessEvents) {
      this.em.dispatchEvent(new CustomEvent('onaudioprocess', {
        detail: {
          inputBuffer: e.inputBuffer,
          outputBuffer: e.outputBuffer
        }
      }))
    }

    // Safari and Edge require manual encoding via web worker. Single channel only for now.
    // Example stereo encoderWav: https://github.com/MicrosoftEdge/Demos/blob/master/microphone/scripts/recorderworker.js
    if (!this.config.usingMediaRecorder) {
      if (this.state === 'recording') {
        if (this.config.broadcastAudioProcessEvents) {
          this.encoderWorker.postMessage(['encode', e.outputBuffer.getChannelData(0)])
        }
        else {
          //console.log("GOGO encoderWorker encode");
          this.encoderWorker.postMessage(['encode', e.inputBuffer.getChannelData(0)])
        }
      }
    }
  }

  cleanupThings () {
    this.chunks = []
    this.chunkType = null

    if (this.destinationNode) {
      this.destinationNode.disconnect()
      this.destinationNode = null
    }
    if (this.outputGainNode) {
      this.outputGainNode.disconnect()
      this.outputGainNode = null
    }

    if (this.processorNode) {
      this.processorNode.disconnect()
      this.processorNode = null
    }

    if (this.encoderWorker) {
      this.encoderWorker.postMessage(['close'])
      this.encoderWorker = null
    }

    if (this.micGainNode) {
      this.micGainNode.disconnect()
      this.micGainNode = null
    }
    if (this.inputStreamNode) {
      this.inputStreamNode.disconnect()
      this.inputStreamNode = null
    }

    if (this.config.stopTracksAndCloseCtxWhenFinished) {
      // This removes the red bar in iOS/Safari
      if (this.micAudioStream) {
        this.micAudioStream.getTracks().forEach((track) => track.stop())
        this.micAudioStream = null
      }
      if (this.audioCtx) {
        this.audioCtx.close()
        this.audioCtx = null
      }
    }    
  }

  async _onDataAvailable (evt) {
    this.chunks.push(evt.data)
    this.chunkType = evt.data.type

    console.log("_onDataAvailable",this.chunkType,this.state,this.chunks.length);
    if (this.state !== 'inactive') {
      return
    }

    /*
    // convert from webm -> wav -> mp3, or for safari wav -> mp3
    // JBB - 2021 - we are now doing this conversion on the backend
    let mp3Buf = null;
    if (this.chunkType.startsWith('audio/webm')) {
      // webm -> wav -> mp3
      console.log(" Converting webm -> wav");
      let tmp_wavBuf = await this.audioWebmToWav(this.chunks);
      console.log(" Converting wav -> mp3");
      mp3Buf = await this.audioWavToMp3(tmp_wavBuf);
    } else {
      // wav -> mp3
      console.log(" Converting wav -> mp3");
      let tmp_wavBuf = await this.readChunk(this.chunks);
      mp3Buf = await this.audioWavToMp3(tmp_wavBuf);
    }

    //let blob = new Blob
    let blob = new window.Blob(mp3Buf, { 'type': 'audio/mpeg' })
    let blobUrl = window.URL.createObjectURL(blob)
    */
    
    let blob = new window.Blob(this.chunks, { 'type': this.chunkType });
    let blobUrl = window.URL.createObjectURL(blob);
    
    const recording = {
      ts: new Date().getTime(),
      blob,
      blobUrl: blobUrl,
      mimeType: blob.type,
      size: blob.size
    }
    //console.log("YO",recording);

    this.cleanupThings();

    this.em.dispatchEvent(new window.CustomEvent('recording', { detail: { recording: recording } }))
  }

  _onError (evt) {
    console.log('error', evt)
    this.em.dispatchEvent(new window.Event('error'))
    alert('error:' + evt) // for debugging purposes
  }
}